import BagelDB from '@bageldb/bagel-db';
export const db = new BagelDB(process.env.VUE_APP_BAGEL_TOKEN);